// These are the well-known variables we currently support. Eventually this should expand to be dynamic, but for
// now this is it.
import type {PromptState} from './prompt-state'

/** Input to the prompt */
export const VariableInput = 'input'

/** Ground truth, expected data */
export const VariableExpected = 'expected'

/** Expanded (=any referenced variables are resolved) prompt */
export const VariablePrompt = 'prompt'

/** Completion from the model for the expanded prompt */
export const VariableCompletion = 'completion'

export type Variables = {
  [key: string]: string
}

export function replaceVars(input: string, vars: Variables): string {
  return input.replace(/{{(.*?)}}/g, (match, key) => vars[key] ?? match)
}

export function referencedVariables(input: string): string[] {
  const matches = input.match(/{{(.*?)}}/g)
  if (matches) {
    const variables = matches.map(m => m.slice(2, -2))
    return Array.from(new Set(variables))
  }
  return []
}

export function referencedVariablesInState({
  prompt: updatedPrompt,
  systemPrompt: updatedSystemPrompt,
  messagePairs: updatedMessagePairs,
}: Partial<PromptState>): string[] {
  let variablesList: string[] = []
  if (updatedPrompt) variablesList = variablesList.concat(referencedVariables(updatedPrompt))
  if (updatedSystemPrompt) variablesList = variablesList.concat(referencedVariables(updatedSystemPrompt))
  if (updatedMessagePairs) {
    for (const pair of updatedMessagePairs) {
      variablesList = variablesList.concat(referencedVariables(pair.user))
      variablesList = variablesList.concat(referencedVariables(pair.assistant))
    }
  }

  const uniqueVariables = new Set(variablesList)
  return Array.from(uniqueVariables)
}
